import { Box, Button, CircularProgress, Stack } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { registerBorrowBookConfirm } from 'src/api/public/registerBorrowBook';
import EmptyContent from 'src/components/empty-content';
import { SCHOOL_ID } from 'src/config-global';
import { useBoolean } from 'src/hooks/use-boolean';
import { RouterLink } from 'src/routes/components';
import { useParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

const CONFIRM_ERRORS = {
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  RESOURCE_HAS_EXPIRED: 'RESOURCE_HAS_EXPIRED',
  RESOURCE_NOT_AVAILABLE: 'RESOURCE_NOT_AVAILABLE',
};
export default function XacNhanMail() {
  const { token } = useParams();
  const isLoading = useBoolean();
  const [errorCode, setErrorCode] = useState<any>(null);

  useEffect(() => {
    if (token) {
      fetch();
    }
    async function fetch() {
      try {
        isLoading.onTrue();

        await registerBorrowBookConfirm({
          token,
          schoolId: SCHOOL_ID,
        });

        enqueueSnackbar('Xác nhận đăng ký mượn ấn phẩm thành công !', { variant: 'success' });
        isLoading.onFalse();
      } catch (error) {
        console.error(error);
        isLoading.onFalse();
        if (!error?.details) {
          enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
          return;
        }
        error.details?.forEach((detail: any) => {
          switch (detail.code) {
            case CONFIRM_ERRORS.RESOURCE_NOT_FOUND:
              enqueueSnackbar(`Không tìm thiếu phiếu đặt trước !`, { variant: 'error' });
              setErrorCode(CONFIRM_ERRORS.RESOURCE_NOT_FOUND);

              break;
            case CONFIRM_ERRORS.RESOURCE_NOT_AVAILABLE:
              enqueueSnackbar(`Sách đặt trước không khả dụng!`, { variant: 'error' });
              setErrorCode(CONFIRM_ERRORS.RESOURCE_NOT_AVAILABLE);
              break;
            case CONFIRM_ERRORS.RESOURCE_HAS_EXPIRED:
              enqueueSnackbar(`Phiếu đặt trước đã hết hạn !`, { variant: 'error' });
              setErrorCode(CONFIRM_ERRORS.RESOURCE_HAS_EXPIRED);
              break;

            default:
              enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
              break;
          }
        });
      }
    }
  }, [token]);

  return (
    <Stack direction="column" spacing={2}>
      {isLoading.value && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={4}
          sx={{ position: 'absolute', width: 1 }}
        >
          <CircularProgress size={80} />
        </Box>
      )}
      {!token && (
        <EmptyContent
          title="Phiếu đặt trước không hợp lệ !"
          imgUrl="/assets/icons/empty/ic_email_disabled.svg"
        />
      )}
      {!isLoading.value && (
        <>
          {!errorCode && (
            <EmptyContent
              title="Xác nhận đăng ký mượn thành công"
              imgUrl="/assets/icons/empty/ic_email_selected.svg"
            />
          )}
          {errorCode === CONFIRM_ERRORS.RESOURCE_NOT_FOUND && (
            <EmptyContent
              title="Không tìm thấy phiếu đăng ký mượn !"
              imgUrl="/assets/icons/empty/ic_email_disabled.svg"
            />
          )}
          {errorCode === CONFIRM_ERRORS.RESOURCE_HAS_EXPIRED && (
            <EmptyContent
              title="Quá thời hạn xác thực. Vui lòng đăng ký lại !"
              imgUrl="/assets/icons/empty/ic_email_disabled.svg"
            />
          )}
          {errorCode === CONFIRM_ERRORS.RESOURCE_NOT_AVAILABLE && (
            <EmptyContent
              title="Ấn phẩm đặt trước không khả dụng. Vui lòng đăng ký lại !"
              imgUrl="/assets/icons/empty/ic_email_disabled.svg"
            />
          )}
          <Button
            component={RouterLink}
            href={paths.guest.tra_cuu}
            variant="contained"
            sx={{ mx: 'auto' }}
          >
            Tra cứu ấn phẩm
          </Button>
        </>
      )}
    </Stack>
  );
}
